/** Restore undoes only this attendance's change: an exclusion, or a modification, never the add. */
import { PlannedItemCommandId, PlannedItemLine } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import { plannedItemRowAction } from './planned.item.command.support';

export const plannedItemRestoreRowCommand = (line: PlannedItemLine, onSaved?: () => void): Command => plannedItemRowAction(PlannedItemCommandId.Restore, line, onSaved);
